import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './CreditNotes.actions';
import reducer, { initialState, IState } from './CreditNotes.reducer';

export const CreditNotesStateContext = createContext<IState>(initialState);
export const CreditNotesDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useCNDispatch = () => useContext(CreditNotesDispatchContext);
export const useCNState = () => useContext(CreditNotesStateContext);
export const useCNContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(CreditNotesStateContext, selector);

interface ICreditNotesStateProvider {
  children: React.ReactNode;
}

const CreditNotesStateProvider = ({ children }: ICreditNotesStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <CreditNotesStateContext.Provider value={state}>
      <CreditNotesDispatchContext.Provider value={dispatch}>
        {children}
      </CreditNotesDispatchContext.Provider>
    </CreditNotesStateContext.Provider>
  );
};

export default CreditNotesStateProvider;
